<!-- <div *ngIf="exported" class="alert">{{ exportedMessage }}</div> -->
<!-- <button (click)="exportCSV()" [ngClass]="{ exportButtonlg: showExportBtn }">Export</button> -->
<div class="export-results" (click)="exportCSV()">
<span class="export-csv" > EXPORT </span>
</div>